import { ScrollableBarChart } from 'pages/Dashboard/components/ScrollableBarChart';
import { ChartContainer, StyledBarChart } from 'pages/Dashboard/components/styled';
import { useMemo } from 'react';
import { Bar, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';
import { useThemeValues } from 'styles/theme';

type FaultTypeCount = {
    FaultTypeId: string;
    FaultTypeName: string;
    Count: number;
};

export function FaultTypesByCount({ data }: { data: FaultTypeCount[] }) {
    const theme = useThemeValues();

    const chartData = useMemo(
        () =>
            data.map((item) => ({
                name: item.FaultTypeName,
                Count: item.Count,
                fill: theme.dashboardAccentPrimary,
            })),
        [data, theme.dashboardAccentPrimary]
    );

    return (
        <ChartContainer>
            <ScrollableBarChart
                yAxisWidth={50}
                dataLength={chartData.length}
                minBarWidthPercent={10}
                height="100%"
            >
                {({ yAxisWidth }) => (
                    // this little bit of margin at the left is to make it less
                    // likely that the first bar label in the x-axis overflows
                    // outside of the svg viewBox to the left. Ideally, I'd like
                    // to offset the svg start, but that requires manually
                    // modifying viewBox afaict, which is difficult to access
                    // here.
                    <StyledBarChart data={chartData} margin={{ bottom: 60, left: 10 }}>
                        <CartesianGrid
                            strokeDasharray="3 3"
                            stroke={theme.borderColor}
                            vertical={false}
                        />
                        <XAxis
                            dataKey="name"
                            angle={-45}
                            textAnchor="end"
                            height={80}
                            interval={0}
                            tick={{ fill: theme.primaryText }}
                        />
                        <YAxis width={yAxisWidth} tick={{ fill: theme.primaryText }} />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: theme.backgroundColor,
                                border: `1px solid ${theme.borderColor}`,
                            }}
                            labelStyle={{ color: theme.primaryText }}
                        />
                        <Bar
                            dataKey="Count"
                            fill={theme.dashboardAccentPrimary}
                            radius={[5, 5, 0, 0]}
                        />
                    </StyledBarChart>
                )}
            </ScrollableBarChart>
        </ChartContainer>
    );
}
